import type { ReactNode } from 'react'
import { FieldHelp, FieldLabel, FieldLabelRow } from '@/components/ui/field'
import { cn } from '@/lib/utils'

/**
 * A field's label with its "what is this for?" info icon beside it. The
 * wording lives in `src/lib/onboarding/field-help.ts`.
 */
export function HintedLabel({
  htmlFor,
  hint,
  required,
  name,
  wrap,
  plain,
  children,
}: {
  htmlFor?: string
  hint: ReactNode
  required?: boolean
  /** The label as plain words, for the icon's name; defaults to the label. */
  name?: string
  /** Let a long label wrap instead of being cut short. */
  wrap?: boolean
  /** Sized like the plain `Label` the fields around it use, so they line up. */
  plain?: boolean
  children: ReactNode
}) {
  const words = name ?? (typeof children === 'string' ? children : 'This field')
  return (
    <FieldLabelRow>
      <FieldLabel
        htmlFor={htmlFor}
        required={required}
        className={cn(plain && 'leading-none', wrap && '[&>span]:whitespace-normal')}
      >
        {children}
      </FieldLabel>
      <FieldHelp label={`What is ${words} for?`}>{hint}</FieldHelp>
    </FieldLabelRow>
  )
}
